<template>
    <div v-if="isNftGated">
        <JoinNftGatedCast :castDetailsProps="castDetails" />
    </div>
    <main v-else class="invite-container">
        <h1> Hosted by <span class="host">{{ creator }}</span>,<br /> you are cordially invited to join as a <span
                class="role">Co-Host</span>. </h1>
        <section class="session-card" aria-label="Session Information">
            <BroadcastIcon />
            <div class="session-card-content">
                <span class="session-card-name">{{ eventName }} <span class="session-card-lb">
                        {{ sentOtp ? '(Private cast)' : '(Public cast)' }}</span></span>
                <!-- <span class="session-card-lb"><span class="status-dot"></span>Your room is live</span> -->
                <div v-if="castDetails && castDetails.time">
                    <CountDownTImer :castDetails="castDetails" />
                </div>
            </div>
        </section>
        <!-- sentOtp -- means cast is private -->
        <div v-if="sentOtp" class="join-card">
            <div class="w-full" v-if="isOtpVerified || isIdentityVerified">
                <div>
                    <div class="join-card-wrapper" v-if="nft">
                        <p>Private NFT drop enabled - connect your wallet, it will link to your email for this cast only
                            to
                            get your airdrop link.</p>
                        <WalletConnectWithSave :email="email" :cast_id="meeting_id"
                            @wallet-email-linked="setIsWalletLinkedWithEmail" />
                    </div>
                    <div class="join-card-wrapper">
                        <form aria-label="Join Session Form" @submit.prevent="joinCast">
                            <input type="text" id="dc-nftcast-handle" name="dc-nftcast-handle" placeholder="Shown to everyone in the cast"
                                autocomplete="off" data-lpignore="true" data-1p-ignore data-form-type="other"
                                aria-label="How you appear to others" required
                                v-model="joiningName" />
                            <button type="submit" :disabled="nft && !isWalletLinkedWithEmail">Join</button>
                        </form>
                    </div>
                </div>
            </div>
            <div class="w-full" v-else>
                <div v-if="!otpSent" class="join-card-wrapper">
                    <p>This is a private cast. Please verify your email before joining the cast. This
                        does not create your decast account</p>
                    <form aria-label="email verification form" @submit.prevent="requestOtp">
                        <input v-validate="'required'" type="email" name="email" placeholder="example@email.com"
                            autocomplete="off" v-model="email" />
                        <button type="submit">Send OTP</button>
                    </form>
                </div>
                <div v-else class="join-card-wrapper">
                    <p>Please enter the OTP sent on your email</p>
                    <form aria-label="otp verification form" @submit.prevent="userVerification">
                        <input v-validate="'required'" type="number" name="otp" placeholder="Enter the OTP"
                            autocomplete="off" v-model="otp" />
                        <button type="submit">Confirm</button>
                    </form>
                </div>
                <div class="divider">Or</div>
                <div class="did-login-section">
                    <DidLogin
                        :allow-guest="false"
                        :require-signature="true"
                        @connected="onDidConnectedForVerification"
                    />
                </div>
            </div>
        </div>
        <div v-else class="join-card">
            <!-- Public cast: Show DID login OR join form (only when not logged in) -->
            <div v-if="showDidLogin && !didConnected && !isLoggedIn" class="did-login-section">
                <DidLogin
                    :allow-guest="true"
                    @connected="onDidConnectedPublic"
                    @disconnected="onDidDisconnectedPublic"
                    @guest="continueAsGuestPublic"
                />
            </div>
            <div v-else>
                <form aria-label="Join Session Form" @submit.prevent="joinCast">
                    <input type="text" id="dc-lcast-handle" name="dc-lcast-handle" placeholder="Shown to everyone in the cast"
                        autocomplete="off" data-lpignore="true" data-1p-ignore data-form-type="other" aria-label="How you appear to others" required v-model="joiningName" :disabled="didConnected" />
                    <button type="submit">Join</button>
                </form>
                <p v-if="isLoggedIn" class="did-status">Joining as {{ joiningName }}</p>
                <p v-else-if="didConnected" class="did-status">Joining with DecastID</p>
                <p v-else class="did-status guest">Joining as guest · <span class="link" @click="showDidLogin = true">use DID</span></p>
            </div>
        </div>
        <!-- <a class="login-link" @click="redirectToLoginPage">Login to Decast</a> -->

        <SelectIdentitiesModal v-if="activeModal === 'selectIdentitiesModal'" :closeModal="() => setActiveModal('')"
            :identities="identities" :meeting_id="meeting_id" @selectIdentity="selectIdentity" @setIdentityVerified="setIdentityVerified" />
    </main>
</template>

<script>
import BroadcastIcon from '../../icons/BroadcastIcon.vue';
import DidLogin from '@/components/common/DidLogin.vue';
import constants from '@/../constant.js';
import axios from '../../../axios';
import WalletConnectWithSave from './WalletConnectWithSave.vue';
import CountDownTImer from './CountDownTImer.vue';
import SelectIdentitiesModal from './SelectIdentitiesModal.vue';
import JoinNftGatedCast from '@/views/new-dashboard/joining-page/JoinNftGatedCast.vue';

export default {
    data() {
        return {
            joiningName: '',
            meeting_id: this.$route.params.meetingID,
            eventName: '',
            eventDescription: '',
            creator: '',
            disabled: false,
            running: false,
            activeSection: 'Verification',
            email: '',
            name: '',
            isOtpVerified: false,
            isIdentityVerified: false,
            otp: '',
            skippedStep: false,
            otpSent: false,
            sentOtp: false,
            password: '',
            nft: false,
            isNftGated: false,
            castDetails: null,
            isWalletLinkedWithEmail: false,

            activeModal: '',
            identities: [],

            // DID state for public casts
            showDidLogin: true,
            didConnected: false,
            connectedDid: '',
            // Logged in user state
            isLoggedIn: false,
        };
    },
    components: {
        BroadcastIcon,
        DidLogin,
        WalletConnectWithSave,
        CountDownTImer,
        SelectIdentitiesModal,
        JoinNftGatedCast,
    },
    mounted() {
        document.getElementById('loading-bg').style.display = 'block';
        this.checkLoginStatus();
        const urlParams = new URLSearchParams(window.location.search);
        const emailParam = urlParams.get('email');
        if (emailParam) {
            this.email = decodeURIComponent(emailParam);
        }
        this.getMeetingDetails();
        this.castInfo();
    },
    computed: {
        validateEmail() {
            return !this.errors.any() && this.email !== '';
        },
        validateOtp() {
            return !this.errors.any() && this.email !== '' && this.otp !== '';
        },
        walletAddress() {
            console.log(this.$store.state.auth.isGetWalletAddress, 'getting wallet');
            return this.$store.state.auth.isGetWalletAddress;
        },
        activeUserInfo() {
            return this.$store.state.AppActiveUser;
        },
    },
    methods: {
        setActiveModal(modalName) {
            this.activeModal = modalName;
        },
        redirectToHomePage() {
            this.$router.push('/');
        },
        redirectToLoginPage() {
            this.$router.push('/v2Login');
        },
        // DID Login handler for identity verification
        async onDidConnectedForVerification(data) {
            const { did, signature, nonceToken } = data;
            if (!signature || !nonceToken) {
                // If no signature, just use DID as display name for public casts
                this.joiningName = data.displayName;
                return;
            }

            try {
                document.getElementById('loading-bg-transparent-title').innerText = 'Verifying your identity...';
                document.getElementById('loading-bg-transparent').style.display = 'flex';

                const didDocument = {
                    '@context': 'https://www.w3.org/ns/did/v1',
                    id: did,
                    verificationMethod: [{
                        id: `${did}#keys-1`,
                        type: 'Ed25519VerificationKey2018',
                        controller: did,
                        publicKeyBase58: did.split(':').pop(),
                    }],
                    authentication: [`${did}#keys-1`],
                };

                const payload = {
                    token: nonceToken,
                    signature,
                    didDocument,
                };

                this.$store.dispatch('auth/v2loginWithDid', payload)
                    .then((response) => {
                        const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
                        if (isTwoFactorAuthEnabled) {
                            const twoFactorToken = response.data?.token;
                            this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
                        } else {
                            this.$store.commit('auth/SET_LOGGEDIN', true);
                            this.$acl.change('user');
                            this.$vs.notify({
                                title: 'Login Successful',
                                text: 'Please select your identity',
                                iconPack: 'feather',
                                icon: 'icon-check-circle',
                                color: 'success',
                            });
                            this.JoinWithJoiningCondition();
                        }
                    })
                    .catch((error) => {
                        console.error('DID login error:', error);
                        const errorResponse = error.response?.data;
                        let message = "DID login failed. Please try again.";
                        if (errorResponse?.status === 400) {
                            message = "Invalid signature or DID verification failed.";
                        } else if (errorResponse?.errors) {
                            message = typeof errorResponse.errors === 'string'
                                ? errorResponse.errors
                                : "Authentication failed.";
                        }
                        this.$vs.notify({
                            title: 'Login Failed',
                            text: message,
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger',
                        });
                    }).finally(() => {
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                    });
            } catch (err) {
                console.error('DID verification error:', err);
                document.getElementById('loading-bg-transparent').style.display = 'none';
                this.$vs.notify({
                    title: 'Error',
                    text: err.message,
                    color: 'danger',
                });
            }
        },
        // Public cast DID handlers
        onDidConnectedPublic(data) {
            this.didConnected = true;
            this.connectedDid = data.did;
            this.joiningName = data.displayName;
            this.showDidLogin = false;
        },
        onDidDisconnectedPublic() {
            this.didConnected = false;
            this.connectedDid = '';
            this.joiningName = '';
            this.showDidLogin = true;
        },
        continueAsGuestPublic() {
            this.showDidLogin = false;
            this.didConnected = false;
        },
        checkLoginStatus() {
            const accessToken = localStorage.getItem('accessToken');
            const userInfo = localStorage.getItem('userInfo');
            if (accessToken && userInfo) {
                try {
                    const user = JSON.parse(userInfo);
                    this.isLoggedIn = true;
                    this.joiningName = user.firstName || user.username || '';
                    this.showDidLogin = false;
                } catch (e) {
                    this.isLoggedIn = false;
                }
            } else {
                this.isLoggedIn = false;
            }
        },
        JoinWithJoiningCondition() {
            this.$store.dispatch('auth/v2verifyAuthToken');
            const userAccount = this.activeUserInfo;
            console.log("this.identities 1", userAccount)
            if (this.sentOtp) { //Otp condition for private call
                if (userAccount.linkedIdentities && userAccount.linkedIdentities.emails) {
                    this.identities = userAccount.linkedIdentities.emails.map((identity, index) => {
                        return {
                            ...identity,
                            isSelected: index === 0 // first one selected
                        };
                    });
                    console.log("this.identities", this.identities)
                    this.setActiveModal('selectIdentitiesModal');
                } else {
                    //if there is no email, redirect to wid for verification
                    this.$vs.notify({
                        title: 'Identities not found!',
                        text: 'Please verify your email to link it as your identitiies',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger',
                    });
                    const query = new URLSearchParams({
                        service: "email-verification",
                        subjects: JSON.stringify(["email"]),
                        conditions: JSON.stringify([
                            {
                                subject: "updatedAt",
                                condition: "gt",
                                value: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
                            }
                        ]),
                        callback_url: `${this.$globals.clientDomain}/did-callback`
                    }).toString()
                    window.open(`${this.$globals.widBaseUrl}/verify?${query}`, "_blank")
                }
            } else {
                // Let the user join if no condition is specified
                this.name = userAccount.firstName;
                this.joinCast();
            }
        },
        setIsWalletLinkedWithEmail(isWalletLinkedWithEmail) {
            this.isWalletLinkedWithEmail = isWalletLinkedWithEmail;
        },
        selectIdentity(index) {
            this.identities.forEach((identity, i) => {
                identity.isSelected = (i === index);
            });
            console.log(index, this.identities)
        },
        setIdentityVerified() {
            const selectedIdentity = this.identities.find(identity => identity.isSelected);
            if (!selectedIdentity) {
                this.$vs.notify({
                    title: 'Identities not selected!',
                    text: 'Please select an indentity to continue',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
                return;
            }
            this.email = selectedIdentity ? selectedIdentity.email : '';
            this.isIdentityVerified = true;
        },
        async castInfo() {
            try {
                //this.$vs.loading();
                const payload = this.meeting_id;
                const response = await this.$store.dispatch(
                    'auth/eventDetail',
                    payload
                );

                this.castDetails = response.data.meeting_info;
                this.isNftGated = response.data.meeting_info.isNftGated;
                this.nft =
                    response.data.meeting_info.give_nft ||
                    response.data.meeting_info.vc_details_submitted;
                this.otpVerification = response.data.meeting_info.send_otp;
                this.password_auth = response.data.meeting_info.password_auth;
                this.public_otp = response.data.meeting_info.public_otp;
                this.is_public = !this.password_auth && !this.otpVerification;
                this.event_creator_name = response.data.meeting_info.event_creator_name;
                this.event_name = response.data.meeting_info.event_name;
                this.event_date = response.data.meeting_info.date;
                this.event_time = response.data.meeting_info.time;
                this.description = response.data.meeting_info.description;
                this.meeting_running = response.data.meeting_info.running;
                this.viewer_mode = response.data.meeting_info.viewer_mode;
                this.isExpired = response.data.meeting_info.expired;
                this.has_magic = this.$route.query.pass !== undefined;
                console.log(this.has_magic);
                //this.$vs.loading.close();
                this.data_loaded = true;
            } catch (err) {
                if (err.status === 404) {
                    this.$router.push('/error/404.vue');
                } else {
                    console.log(err);
                }
            }
        },
        async getMeetingDetails() {
            const res = await this.$store.dispatch(
                'cast/meetingInfo',
                this.meeting_id
            );
            const details = res.data.meeting_info;
            this.castDetails = details;
            this.isNftGated = details.isNftGated;
            this.sentOtp = details.send_otp;
            this.eventName = details.event_name;
            this.eventDescription = details.description;
            this.creator = details.event_creator_name;
            this.running = details.running;
            document.getElementById('loading-bg').style.display = 'none';
        },
        async saveUser() {
            await fetch(`${this.$globals.transcriptionBaseUrl}/api/audio/save_name/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    name: this.joiningName,
                    public_meeting_id: this.meeting_id,
                }),
            });
        },
        async joinCast() {
            // const credentials = this.extractCredentials();
            // console.log('my credentials are', credentials);
            const payload = {
                name: this.joiningName,
                email: !this.sentOtp ? '' : this.email,
                password: !this.sentOtp ? this.$route.query.pass : '',
                public_meeting_id: this.meeting_id,
                avatar_url: '',
                isPublic: !this.sentOtp,
            };

            if (!this.sentOtp) {
                const joineePayload = {
                    user_name: this.joiningName,
                    user_email: payload.email || '',
                    session_id: payload.public_meeting_id,
                };

                document.getElementById('loading-bg-transparent-title').innerText = `Hang tight, ${this.joiningName} 🚀 Redirecting to the meeting`;
                document.getElementById('loading-bg-transparent').style.display = 'flex';
                await this.$store
                    .dispatch('studio/addJoinee', joineePayload)
                    .then(async (response) => {
                        if (response.data.status) {
                            if (this.$route.query.pass !== undefined) {
                                await this.magicJoin(payload);
                            } else {
                                await this.joinCastUtil(payload);
                            }
                        }
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                    })
                    .catch((err) => {
                        console.log(err);
                        // this.$vs.loading.close();
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                        this.disabled = false;
                        this.$vs.notify({
                            title: 'Error Occurred',
                            text:
                                err.response != null
                                    ? err.response.data.message
                                    : 'Something went wrong! Try Again',
                            color: 'danger',
                        });
                    });
            } else {
                if (this.$route.query.pass !== undefined) {
                    await this.magicJoin(payload);
                } else {
                    this.joinCastUtil(payload);
                }
            }
        },
        storeData() {
            sessionStorage.setItem('verified', this.isOtpVerified);
            // sessionStorage.setItem('email', this.email);
        },
        joinCastUtil(payload) {
            console.log('----->');
            document.getElementById('loading-bg-transparent-title').innerText = `Hang tight, ${payload.name} 🚀 Redirecting to the meeting`;
            document.getElementById('loading-bg-transparent').style.display = 'flex';
            this.$store
                .dispatch('studio/joinEvent', payload)
                .then((response) => {
                    this.saveUser()
                    this.responsedata = response.data.url;
                    window.location.href = response.data.url;
                    this.$posthog.trackCastJoined(this.meeting_id);
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    this.$vs.notify({
                        title: 'Success',
                        text: response.data.message,
                        color: 'success',
                    });
                })
                .catch((e) => {
                    console.log(e.response);
                    // this.$vs.loading.close();
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    this.disabled = false;
                    this.$vs.notify({
                        title: 'Error Occurred',
                        text:
                            e.response != null
                                ? e.response.data.message
                                : 'Check either your password or the cast timing',
                        color: 'danger',
                    });
                });
        },
        async magicJoin(payload) {
            var data = JSON.stringify({
                id: this.meeting_id,
                pass: this.$route.query.pass,
                name: this.joiningName,
            });
            document.getElementById('loading-bg-transparent-title').innerText = `Hang tight, ${this.joiningName} 🚀 Redirecting to the meeting`;
            document.getElementById('loading-bg-transparent').style.display = 'flex';
            console.log(178);
            await this.$store
                .dispatch('studio/magicJoin', data)
                .then((res) => {
                    console.log(res.data.url, 181);
                    if (res.data.url) {
                        console.log(184);
                        this.$vs.notify({
                            title: 'Success',
                            color: 'success',
                        });
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                        this.$posthog.trackCastJoined(this.meeting_id);
                        this.saveUser();
                        location.href = res.data.url;
                    } else {
                        // this.$vs.loading.close();
                        this.disabled = false;
                        this.$vs.notify({
                            title: 'Wrong Link',
                            text: 'You have the wrong link to join',
                            color: 'danger',
                        });
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                    }
                })
                .catch((e) => {
                    if (!this.running && e.response.status === 400) {
                        this.$vs.notify({
                            title: 'Cast not started yet!',
                            text: 'The cast you are trying to join has either ended or yet to begin',
                            color: 'danger',
                        });
                    }
                    // this.$vs.loading.close();
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    this.disabled = false;
                    console.log(e.response);
                });
        },
        accessCast() {
            if (this.disabled) {
                return;
            }
            this.disabled = true;
            setTimeout(() => {
                this.disabled = false;
            }, 1000);
            if (this.joiningName.length === 0) {
                this.$vs.notify({
                    title: 'Name require',
                    color: 'danger',
                });
                return;
            }
            var data = JSON.stringify({
                id: this.meeting_id,
                pass: !this.sentOtp ? this.$route.query.pass : '',
                name: this.joiningName,
            });
            sessionStorage.setItem('name', this.joiningName);
            // this.$vs.loading();
            document.getElementById('loading-bg-transparent-title').innerText = `Hang tight, ${this.joiningName} 🚀 Redirecting to the meeting`;
            document.getElementById('loading-bg-transparent').style.display = 'flex';
            console.log(178);
            this.$store
                .dispatch('studio/magicJoin', data)
                .then((res) => {
                    console.log(res.data.url, 181);
                    if (res.data.url) {
                        console.log(184);
                        this.$vs.notify({
                            title: 'Success',
                            color: 'success',
                        });
                        location.href = res.data.url;
                    } else {
                        // this.$vs.loading.close();
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                        this.disabled = false;
                        this.$vs.notify({
                            title: 'Wrong Link',
                            text: 'You have the wrong link to join',
                            color: 'danger',
                        });
                    }
                })
                .catch((e) => {
                    // this.$vs.loading.close();
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    console.log(e.response);
                });
        },
        reloadStepOne() {
            this.isOtpVerified = false;
            this.goBack();
            this.reloadStepTwo();
        },
        reloadStepTwo() {
            this.skippedStep = false;
            this.$store.dispatch('auth/removeWalletAddress', false);
        },
        requestOtp() {
            if (this.email === '') {
                this.$vs.notify({
                    title: 'Email Required',
                    text: 'Please enter email to proceed further',
                    color: 'danger',
                });
                return;
            }
            // this.$vs.loading();
            document.getElementById('loading-bg-transparent-title').innerText = '📨 Sending OTP';
            document.getElementById('loading-bg-transparent').style.display = 'flex';

            const payload = {
                email: this.email.toLowerCase(),
                meeting_id: this.$route.params.meetingID,
            };

            this.$store
                .dispatch('auth/sendingOtp', payload)
                .then((res) => {
                    console.log(res.data);
                    // this.$vs.loading.close();
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    if (res.data.status) {
                        this.otpSent = true;
                        this.$vs.notify({
                            // title: 'Error',
                            text: this.$t('Verification.otpsent'),
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success',
                        });
                    }
                })
                .catch((e) => {
                    console.log(e.response.data);
                    // this.$vs.loading.close();
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    if (e.response.data.message === 'invalid email')
                        this.$vs.notify({
                            title: 'Unauthorized!',
                            text: 'This email is not invited to this cast',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger',
                        });
                    else {
                        this.$vs.notify({
                            title: 'Error Occurred',
                            text: 'Try Again',
                            color: 'danger',
                        });
                    }
                });
        },
        userVerification() {
            const payload = {
                email: this.email,
                meeting_id: this.$route.params.meetingID,
                otp: this.otp,
            };
            // Loading
            // this.$vs.loading();
            document.getElementById('loading-bg-transparent-title').innerText = '🔄 Verifying your OTP';
            document.getElementById('loading-bg-transparent').style.display = 'flex';
            this.$store
                .dispatch('auth/verifyingOtp', payload)
                .then((res) => {
                    // this.$vs.loading.close();
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    if (res.data.status) {
                        this.isOtpVerified = true;
                    }
                    this.$vs.notify({
                        title: 'Congrats',
                        text: 'Verified',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success',
                    });
                    this.activeSection = 'Join';
                })
                .catch(() => {
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    this.$vs.notify({
                        title: 'Error',
                        text: this.$t('Verification.correctotp'),
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger',
                    });
                });
        },
        goBack() {
            this.otpSent = false;
        },
        skipStep() {
            this.skippedStep = true;
        },
    }
}
</script>

<style scoped>
*:not(i) {
    font-family: 'Rethink Sans' !important;
}

.invite-container {
    text-align: center;
    max-width: 500px;
    width: 100%;
    padding: 20px;
}

h1 {
    font-size: 20px;
    margin-bottom: 0.75rem;
    color: rgba(255, 255, 255, 80%);
    line-height: 1.6;
    text-align: left;
}

h1 .host {
    color: #D3CA57;
    font-weight: 600;
}

h1 .role {
    color: #D3CA57;
    font-weight: 600;
}

.session-card {
    border: 1px solid rgba(255, 255, 255, 10%);
    border-radius: 8px;
    padding: 15px;
    margin: 20px 0;
    display: flex;
    align-items: center;
}

.session-card-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-left: 10px;
}

.session-card-name {
    font-size: 16px;
    color: #FFFFFF;
    font-weight: 600;
}

.session-card-lb {
    font-size: 14px;
    color: rgba(255, 255, 255, 70%);
    font-weight: 400;
}

.status-dot {
    height: 10px;
    width: 10px;
    background-color: #5EC16A;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;
}

form {
    width: 100%;
    display: flex;
    margin: 15px 0;
    justify-content: center;
    border: 1px solid rgba(255, 255, 255, 10%);
    border-radius: 8px;
}

.join-card {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.join-card-wrapper {
    width: 100%;
    flex-direction: column;
}

.join-card-wrapper p {
    text-align: left;
    color: rgba(255, 255, 255, 50%);
}

.did-btn {
    border: 1px solid rgba(255, 255, 255, 50%);
    border-radius: 8px;
    background-color: #15161F;
    margin: 15px 0px 15px 10px;
    padding: 0px;
    height: 40px;
    width: 100%;
    min-width: 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
}

.did-btn:hover {
    background-color: transparent !important;
}

.did-btn svg {
    height: 16px;
    width: 16px;
}

.did-btn span {
    color: #FFFFFF;
    margin-left: 10px;
    font-size: 14px;
    font-weight: 400;
}

input[type="text"] {
    flex: 1;
    padding: 10px;
    border-radius: 8px 0 0 8px;
    border: none;
    outline: none;
    background-color: #15161F;
    color: #FFFFFF;
    font-size: 1rem;
}

input {
    flex: 1;
    padding: 10px;
    border-radius: 8px 0 0 8px;
    border: none;
    outline: none;
    background-color: #15161F;
    color: #FFFFFF;
    font-size: 1rem;
}

button {
    background-color: #D3CA57;
    border: none;
    padding: 10px 20px;
    font-size: 1rem;
    font-weight: 600;
    border-radius: 0 8px 8px 0;
    cursor: pointer;
    transition: background 0.2s ease;
    color: #000000;
}

button:hover {
    background-color: #ebe369;
}

button:disabled {
    cursor: not-allowed;
    opacity: 0.8;
}

.divider {
    margin: 20px 0;
    display: flex;
    align-items: center;
    text-align: center;
    color: #999;
    font-size: 0.85rem;
}

.divider::before,
.divider::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #2b2b33;
}

.divider:not(:empty)::before {
    margin-right: 0.75em;
}

.divider:not(:empty)::after {
    margin-left: 0.75em;
}

.login-link {
    color: #FFFFFF;
    border-bottom: 1px solid #FFFFFF;
    text-decoration: none;
    font-weight: 500;
}

.login-link:hover {
    text-decoration: underline;
}

/* DID Login Section */
.did-login-section {
    margin: 10px 0;
}

.did-status {
    font-size: 12px;
    color: #5EC16A;
    margin-top: 8px;
}

.did-status.guest {
    color: rgba(255, 255, 255, 0.5);
}

.did-status .link {
    color: #D3CA57;
    cursor: pointer;
    text-decoration: underline;
}

.did-status .link:hover {
    color: #ebe369;
}
</style>
